(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["text"] && !Shopify.designMode) return;
  try {
    class TextCollapsible extends HTMLElement {
    connectedCallback() {
      this.inner = this.querySelector('.text-collapsible__inner');
      this.toggle = this.querySelector('.text-collapsible__toggle');

      if (!this.inner || !this.toggle) return;

      this.toggle.addEventListener('click', () => {
        const expanded = this.classList.toggle('is-expanded');
        this.toggle.setAttribute('aria-expanded', String(expanded));
      });

      const init = () => {
        const collapsedHeight = parseFloat(getComputedStyle(this).getPropertyValue('--collapsed-height')) || 300;
        const fullHeight = this.inner.scrollHeight;

        this.style.setProperty('--full-height', fullHeight + 'px');

        if (fullHeight <= collapsedHeight) {
          this.toggle.hidden = true;
          this.inner.style.height = 'auto';
          this.inner.style.overflow = 'visible';
        }
      };

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(init);
      } else {
        window.addEventListener('load', init, { once: true });
      }
    }
  }

  if (!customElements.get('text-collapsible')) {
    customElements.define('text-collapsible', TextCollapsible);
  }
  } catch(e) { console.error(e); }
})();

})();
